<div>
  <ion-text color="primary"><h2>{{translationKey + '.help_dialog.title' | translate }}</h2></ion-text>
  <ion-text [innerHTML]="translationKey + '.help_dialog.text' | translate"></ion-text>
  <ion-text color="primary"><h2>{{'QUIZ.help_dialog.mechanics.navigate.title' | translate }}</h2></ion-text>
  <ion-text [innerHTML]="'QUIZ.help_dialog.mechanics.navigate.text' | translate"></ion-text>
  <ion-text color="primary"><h2>{{'QUIZ.help_dialog.mechanics.finish.title' | translate }}</h2></ion-text>
  <ion-text [innerHTML]="'QUIZ.help_dialog.mechanics.finish.text' | translate"></ion-text>
</div>
